import { useState } from "react";
import {
  ControllerMemberSearchListItem,
  ControllerMemberSearchListWrapper,
  ControllerMemberSearchWrapper,
} from "../style";
import { useRecoilValue } from "recoil";
import { useParams } from "react-router-dom";
import {
  PubMemberDto,
  UserMemberResponse,
  getPubMemberList,
  getUserAndMemberByNickname,
} from "../../../../../../../api/member";
import { getTournamentUser } from "../../../../../../../api/tournament-participant";
import { pubState } from "../../../../../../../recoil/pub.atom";
import { TimerControllerPopupInputWrapper } from "../../../../../style";
import { useParticipantContext } from "../../../hooks/participant-context";
import { WideState } from "../../../../../../../recoil/wide";
import TimerControllerMemberJoin from "../../../../member-join";

export interface ControllerMemberSearchProps {
  setMember: (v: PubMemberDto | null) => void;
}

const ControllerParticipationSearch = ({
  setMember,
}: ControllerMemberSearchProps) => {
  const { reservationList } = useParticipantContext();
  const pub = useRecoilValue(pubState);
  const isWide = useRecoilValue(WideState);
  const { id } = useParams();
  const tournamentId = id?.replace(/[^0-9]/g, "");
  const [list, setList] = useState<UserMemberResponse[]>([]);
  const [isSearch, setIsSearch] = useState<boolean>(false);
  const [nickname, setNickname] = useState<string>("");

  // 회원 추가
  const [isJoin, setIsJoin] = useState<boolean>(false);
  const [joinMember, setJoinMember] = useState<UserMemberResponse | null>(null);

  const getMemberMoreText = (item: UserMemberResponse) => {
    if (!item.memberId) return " (비회원)";

    if (!item.isAdult) return " (미성년자)";

    if (item.isSitIn) return " (참여중)";

    if (
      reservationList.some(
        (reservation) => reservation.nickname === item.nickname
      )
    )
      return " (예약회원)";
  };

  // 멤버 선택
  const handleSelectMember = async (member: UserMemberResponse) => {
    if (!member) return;
    if (!member.isAdult) {
      alert("미성년자입니다.");
      return;
    }
    if (member.isSitIn) {
      alert("이미 참여중인 유저입니다. ");
      return;
    }
    if (
      reservationList.some(
        (reservation) => reservation.nickname === member.nickname
      )
    ) {
      alert("예약된 유저입니다. 예약자 싯인에서 싯인해주세요. ");
      return;
    }

    if (pub?.id && member.memberId) {
      const result = await getPubMemberList(member.nickname, pub.id);
      setMember(
        result?.memberList.find((item) => item.memberId === member.memberId) ??
          null
      );
      setIsSearch(false);
    } else {
      setJoinMember(member);
      setIsJoin(true);
    }
  };

  // 닉네임 검색
  const handleSearchNickname = async () => {
    if (!pub || !tournamentId) return;
    if (!nickname) {
      alert("닉네임을 입력해주세요. ");
      return;
    }
    try {
      const res = await getUserAndMemberByNickname(nickname, pub.id);
      const participation = await getTournamentUser(
        +tournamentId,
        1,
        100,
        nickname
      );
      setList([]);
      setIsSearch(true);

      // 싯인상태 저장
      const list: UserMemberResponse[] = [];
      res.payload.forEach((item) => {
        list.push({
          ...item,
          isSitIn: participation.list.some(
            (member) => member.memberId === item.memberId
          ),
        });
      });

      // 참가 가능 회원 순 정렬
      list.sort((a, b) => {
        const aText = getMemberMoreText(a);
        const bText = getMemberMoreText(b);

        if (!aText && bText) return -1;
        if (aText && !bText) return 1;
        return 0;
      });

      const filterList = list.filter((item) => item.isAdult === true);

      setList(filterList);
    } catch (error: any) {
      if (error.response && error.response.status === 404) {
        alert("검색한 닉네임을 찾을 수 없습니다.");
      } else {
        alert("에러가 발생했습니다. 다시 시도해주세요.");
      }
    }
  };

  if (isJoin) {
    return (
      <TimerControllerMemberJoin
        joinMember={joinMember}
        setMember={setMember}
        onClose={() => {
          setIsJoin(false);
          setJoinMember(null);
        }}
      />
    );
  }

  return (
    <ControllerMemberSearchWrapper>
      <TimerControllerPopupInputWrapper height={isWide ? "45px" : "33px"}>
        <input
          enterKeyHint="search"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          placeholder="닉네임을 검색하세요. "
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSearchNickname();
          }}
        />
      </TimerControllerPopupInputWrapper>
      {isSearch && (
        <ControllerMemberSearchListWrapper>
          {list.map((item, index) => (
            <ControllerMemberSearchListItem
              key={index}
              onClick={() => handleSelectMember(item)}
              isWide={isWide}
            >
              <div>{item.nickname}</div>
              {getMemberMoreText(item) && (
                <span>{getMemberMoreText(item)}</span>
              )}
            </ControllerMemberSearchListItem>
          ))}
        </ControllerMemberSearchListWrapper>
      )}
    </ControllerMemberSearchWrapper>
  );
};

export default ControllerParticipationSearch;
